import { Component, OnInit, ViewChild, ChangeDetectorRef, OnChanges } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { PackageModel } from 'src/app/model/stripe-models/product/package-model';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { HeaderServiceService } from 'src/app/services/header-service/header-service.service';
import { Subscriptions } from 'src/app/model/stripe-models/subscription/Subscribtions';
import { of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { SubscriptionData } from 'src/app/model/stripe-models/subscription/subscription-data';

@Component({
    selector: 'app-abonnement-page',
    templateUrl: './abonnement-page.component.html',
    styleUrls: ['./abonnement-page.component.scss'],
    standalone: false
})
export class AbonnementPageComponent implements OnInit, OnChanges {

  public ProductsToShow: PackageModel[] = [];
  private destroy$ = new Subject<void>();
  subscriptions: Subscriptions;
  totalNumberOfElements: number;
  pageIndex = 0;
  pageSize = 5;
  activeOrg;
  loading: boolean = false;
  isSubscriptionSelected = false;
  selectedSubscription: SubscriptionData = null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private stripeService: StripeService,
    private userService: UserService,
    public headerService: HeaderServiceService) {
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.activeOrg = this.headerService.activeOrganisation.organisationId;
    await this.stripeService.loadProducts();
    this.loadProducts();
    this.getSubscriptionDataSize(this.activeOrg.toString());
    this.getSubscriptionData(this.activeOrg.toString(), '', this.pageSize.toString());
  }

  ngOnChanges(): void {
    this.cdr.detectChanges();
    this.loading = false;
  }

  onPageChange(pageChangeEvent: PageEvent) {
    this.loading = true;
    this.cdr.detectChanges();
    const previousIndex = this.pageIndex;
    const previousPageSize = this.pageSize;
    this.pageIndex = pageChangeEvent.pageIndex;
    this.pageSize = pageChangeEvent.pageSize;
    let paginationDirectionBill: string;
    if (this.subscriptions && this.subscriptions.subscriptions.length > 0) {
      if (this.pageSize != previousPageSize) {
        paginationDirectionBill = '';
        this.pageIndex = 0;
      }
      else if (this.pageIndex > previousIndex) {
        paginationDirectionBill = '&starting_after=' + this.subscriptions.subscriptions[this.subscriptions.subscriptions.length - 1].id;
      }
      else if (this.pageIndex < previousIndex) {
        paginationDirectionBill = '&ending_before=' + this.subscriptions.subscriptions[0].id;
      }
    }
    this.getSubscriptionData(this.activeOrg, paginationDirectionBill, this.pageSize.toString());
    this.cdr.detectChanges();
  }

  getSubscriptionData(activeOrg: string, paginationDirectionBill: string, limit: string) {
    this.loading = true;
    this.stripeService.getSubscriptionData(activeOrg, paginationDirectionBill, limit)
      .pipe(catchError(error => { return of([]); }))
      .subscribe((data: Subscriptions) => {
        if (data) {
          this.subscriptions = data;
          this.loading = false;
          this.cdr.detectChanges();
        }
        else {
          this.loading = false;
          this.cdr.detectChanges();
        }
      });
  }

  getSubscriptionDataSize(activeOrg: string) {
    this.stripeService.getSubscriptionDataSize(activeOrg)
      .pipe(catchError(error => { return of("0"); }))
      .subscribe(data => {
        if (typeof data === 'string') { this.totalNumberOfElements = Number(data); }
        else { this.totalNumberOfElements = 0; }
        this.cdr.detectChanges();
      });
  }

  handleAbonnementAction() {
    this.isSubscriptionSelected = true;
    this.subscriptions.subscriptions.forEach(subscription => {
      if (subscription.id === this.selectedSubscription.id)
        subscription = this.selectedSubscription;
    })
  }

  goBack(): void {
    this.getSubscriptionData(this.activeOrg.toString(), '', this.pageSize.toString());
    this.isSubscriptionSelected = false;
  }

  public showTarifeSelectionDialog() {
    this.dialogService.openTarifeSelectionDialog('', '', this.ProductsToShow)
      .subscribe((dialogResult) => {
        if (typeof dialogResult === 'number') {
          this.getSubscriptionDataSize(this.activeOrg.toString());
          this.getSubscriptionData(this.activeOrg.toString(), '', this.pageSize.toString());
        }
      });
  }

  isUserAdminOfOrganisationOrPlattformAdmin() {
    return this.userService.isUserAdminOfOrganisationOrPlattformAdmin(
      this.activeOrg
    );
  }


  private loadProducts(): void {
    this.stripeService.ProductsToShowObservable
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(products => {
        this.ProductsToShow = products;
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
